import React from 'react';
import PropTypes from 'prop-types';

import './PreFiltersSummary.scss';

const PreFiltersSummary = ({ title }) => (
  <div className="pre-filters-summary" data-test="prefilters-summary">
    <span
      className="pre-filters-summary__title"
      data-test="prefilters-summary-title"
    >
      {title}
    </span>
  </div>
);

PreFiltersSummary.propTypes = {
  title: PropTypes.string.isRequired
};

export default PreFiltersSummary;
